import EditModal from './EditModal.vue'
import Vue from 'vue'

const EditModalConstructor = Vue.extend(EditModal)

export default function (options) {
  return new Promise(resolve => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }

    const instance = new EditModalConstructor({
      data: options
    })

    // 监听组件事件来获取 message
    instance.$on('confirm', function (message) {
      console.log('message', message)
      resolve({
        result: true,
        message: message
      })
      instance.visible = options.doNotCloseDialog === true
    })

    instance.$on('cancel', function (message) {
      console.log('message', message)
      resolve({
        result: false,
        message: message
      })
      instance.visible = options.doNotCloseDialog === true
    })

    instance.handleClose = function () {
      resolve(undefined)
      instance.visible = false
    }

    instance.$mount()
    document.body.appendChild(instance.$el)
  })
}
